import {
  Component, Prop, Vue,
} from 'vue-property-decorator';

import type { HomeBodyConfig } from '@/shared/utils/pageTheme';

import style from './index.module.scss';

export enum ImageStatusEnum {
  LOADING = 'loading',
  ERROR = 'error',
  SUCCESS = 'success',
}

@Component
export default class ThemeBanner extends Vue {
  @Prop(Object) private themeConfig!: HomeBodyConfig;

  private themeImageStatus: ImageStatusEnum = ImageStatusEnum.LOADING;

  private onBannerClickBox(e: Event) {
    this.$emit('themeBannerClick', e);
  }

  private setThemeImageStatus(status: ImageStatusEnum) {
    this.themeImageStatus = status;
  }

  private render() {
    const {
      isValidTheme,
      priorityImageUrl,
      clickAction,
    } = this.themeConfig || {};

    if (isValidTheme) {
      return (
        <div class={style.themeBanner}>
          <img
            src={priorityImageUrl}
            class={style.customeThemeImg}
            status={this.themeImageStatus}
            onError={() => this.setThemeImageStatus(ImageStatusEnum.ERROR)}
            onLoad={() => this.setThemeImageStatus(ImageStatusEnum.SUCCESS)}
          />
          {clickAction ? (
            <div class={style.bannerClickBox} onClick={(e: Event) => this.onBannerClickBox(e)} />)
            : null
          }
        </div>
      );
    }

    return null;
  }
}
